import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import BulkContainer from "@/pages/BulkContainer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BulkContainer />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors theme="light" />
    </div>
  );
}

export default App;
